import React from 'react';
import PropTypes from 'prop-types';

import Loader from 'relements/build/esm/ui/loader';

import THEMES from '@src/components/JsonPicker/Themes';

// Error boundary
import ErrorBoundary from '@src/components/ErrorBoundary';
import { retryLazyLoad } from '@src/components/ErrorBoundary/utils';

import styles from './DebugDetails.scss';

const JSONTree = React.lazy(() =>
  retryLazyLoad(() => import('react-json-tree'))
);

/**
 * This function displays the raw json using JSON tree
 * @param {Object} prop - Object containing all the props
 * @param {Object} prop.debugData - contains the raw logs of the respective message
 */
function DebugDetails({ debugData }) {
  return (
    <div className={styles.debugDetails}>
      <ErrorBoundary>
        <React.Suspense
          fallback={
            <div className={styles.debugDetailsLoader}>
              <Loader />
            </div>
          }
        >
          <JSONTree data={debugData} theme={THEMES.tomorrow} hideRoot />
        </React.Suspense>
      </ErrorBoundary>
    </div>
  );
}

DebugDetails.propTypes = {
  debugData: PropTypes.shape({}),
};

DebugDetails.defaultProps = {
  debugData: {},
};

export default DebugDetails;
